<!-- content with page header -->
<app-page-body *ngIf="!pageConfig.isVisibleHelpPage">
  <!---------------------------------- header ---------------------------------->
  <app-page-header
    [title]="pageConfig?.title"
    [loading]="pageConfig?.loading"
    [showDefaultBtns]="false"
  >
    <div class="card-toolbar" custom-elements>
      <!-- refresh btn -->
      <a
        class="btn btn-light txt-lg button-shadow tw-mx-1 text-blue btn-hover-rise"
        mat-ripple
        [matTooltip]="'common.refresh' | translate"
        (click)="onRefresh()"
      >
        <i class="mdi mdi-refresh mdi-20px tw-p-0 text-blue"></i>
      </a>
      <!-- help btn -->
      <a
        class="btn btn-light txt-lg button-shadow tw-mx-1 text-info btn-hover-rise"
        mat-ripple
        [matTooltip]="'pages.help.title' | translate"
        (click)="onShowHelpPage()"
      >
        <i class="mdi mdi-help-circle mdi-20px !tw-p-0 text-success"></i>
      </a>
    </div>
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <div class="row">
      <ng-container *ngIf="!pageConfig.loading">
        <div
          class="tw-mt-8 tw-grid 2xl:tw-grid-cols-4 xl:tw-grid-cols-3 sm:tw-grid-cols-2 tw-grid-cols-1 tw-gap-x-4 tw-card"
          page-body
        >
          <div *ngFor="let item of items; let i = index">
            <div
              class="tw-rounded tw-overflow-hidden tw-shadow-lg tw-bg-white dark:tw-bg-dark-300 tw-mb-5 tw-h-72"
            >
              <div
                class="tw-font-medium tw-text-base tw-p-4 tw-flex tw-justify-between tw-items-center tw-mt-3 tw-h-5"
              >
                <!-- delete button -->
                <div *ngIf="i != 0">
                  <div (click)="onDelete(item?.sessionId, item?.userName)">
                    <i
                      class="mdi mdi-close-circle !tw-text-red-500 mdi-28px tw-cursor-pointer"
                      [matTooltip]="'common.endOfSessions' | translate"
                    ></i>
                  </div>
                </div>
              </div>

              <div class="tw-flex-center tw-mb-2 tw-h-10">
                <div
                  class="tw-text-primary-900 tw-text-xl tw-font-semibold tw-mb-1 dark:tw-text-gray-400"
                >
                  {{ item?.ipAddress | ipDisplayer }}
                </div>
                <i
                  *ngIf="i == 0"
                  class="mdi mdi-check-decagram tw-text-green-500 mdi-24px tw-mb-1 tw-px-2"
                  [matTooltip]="'common.currentMeeting' | translate"
                ></i>
              </div>

              <div
                class="tw-flex tw-justify-between tw-border-b tw-border-gray-100 dark:tw-border-gray-700 tw-mb-3"
              >
                <!--#region created-->
                <div
                  class="tw-mx-7 tw-py-3 tw-flex tw-flex-col tw-items-center tw-w-80"
                >
                  <div class="tw-flex-center">
                    <div
                      class="tw-text-base tw-font-semibold tw-text-primary-900 tw-mb-2 dark:tw-text-gray-300 tw-whitespace-nowrap"
                    >
                      {{ "common.login" | translate }}
                    </div>
                  </div>
                  <div>
                    <td-value
                      type="dateTime"
                      [value]="item?.created"
                      fontSize="md"
                      class="tw-text-base tw-font-medium tw-text-gray-400 dark:tw-text-gray-400 tw-whitespace-nowrap"
                    ></td-value>
                  </div>
                </div>
                <!--#endregion-->

                <!--#region created-->
                <div
                  class="tw-mx-7 tw-py-3 tw-flex tw-flex-col tw-items-center tw-w-80"
                >
                  <div class="tw-flex-center">
                    <div
                      class="tw-text-base tw-font-semibold tw-text-primary-900 tw-mb-2 dark:tw-text-gray-300 tw-whitespace-nowrap"
                    >
                      {{ "common.userName" | translate }}
                    </div>
                  </div>
                  <div>
                    <span
                      class="tw-text-base tw-font-medium tw-text-gray-400 dark:tw-text-gray-400 tw-whitespace-nowrap"
                      >{{ item?.userName }}</span
                    >
                  </div>
                </div>
                <!--#endregion-->
              </div>

              <div class="tw-flex tw-justify-around tw-items-center tw-mt-4">
                <!--#region browser-->
                <div
                  class="tw-mx-6 tw-py-1 tw-flex tw-flex-col tw-items-center"
                >
                  <div
                    class="tw-text-base tw-font-medium tw-text-primary-900 dark:tw-text-gray-300"
                  >
                    {{ "common.browser" | translate }}
                  </div>
                  <span
                    *ngIf="item?.browser || item?.browser == 1"
                    [matTooltip]="item?.browserName"
                  >
                    <i [browserIcon]="item?.browser"></i>
                  </span>
                  <span *ngIf="!item?.browser">
                    {{ item?.browserName }}
                  </span>
                </div>
                <!--#endregion-->

                <!--#region device-->
                <div
                  class="tw-mx-6 tw-py-1 tw-flex tw-flex-col tw-items-center"
                >
                  <div
                    class="tw-text-base tw-font-medium tw-text-primary-900 dark:tw-text-gray-300"
                  >
                    {{ "common.device" | translate }}
                  </div>
                  <span *ngIf="item?.device" [matTooltip]="item?.os">
                    <i [deviceIcon]="item?.device"></i>
                  </span>
                  <span *ngIf="!item?.device">
                    {{ item?.device }}
                  </span>
                </div>
                <!--#endregion-->

                <!--#region platform-->
                <div
                  class="tw-mx-6 tw-py-1 tw-mb-2 tw-flex tw-flex-col tw-items-center"
                >
                  <div
                    class="tw-text-base tw-font-medium tw-text-primary-900 dark:tw-text-gray-300"
                  >
                    {{ "common.platform" | translate }}
                  </div>
                  <span
                    *ngIf="item?.platform || item?.platform == 1"
                    [matTooltip]="item?.os"
                  >
                    <i [platformIcon]="item?.platform"></i>
                  </span>
                  <span *ngIf="!item?.platform">
                    {{ item?.os }}
                  </span>
                </div>
                <!--#endregion-->
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</app-page-body>
<!---------------------------------------- help ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
